import { PROVISIONED_UI_FLAGS } from '@Builder/QuoteDetailPage/logic'

import { getUserIdentity } from '~/redux-modules/identity'
import isFlagEnabled from '~/lib/isFlagEnabled'

export const FABRICATE = 'fabricate'
export const USER_ADDED_TO_BUSINESS_ACCOUNT_TITLE =
    'You’ve been successfully added to your Business Account’s Fictiv Premium trial.'
export const PREMIUM_TRIAL_ACTIVATION_TITLE =
    '                You have successfully activated Fictiv Premium trial.'
export const selectFlags = state => {
    const identity = getUserIdentity(state)
    const isTeamsFeatureEnabledForUser =
        identity?.businessAccountMembership?.businessAccount
            ?.isTeamsFeatureEnabled

    return {
        identity,
        isGetEarlyAccessTeamsFlagEnabled:
            isFlagEnabled(
                identity,
                PROVISIONED_UI_FLAGS.RELEASE_GET_EARLY_ACCESS_TEAMS,
                'true',
            ) && !isTeamsFeatureEnabledForUser,
        isReleasePremiumUpsellDrawerUIEnabled: isFlagEnabled(
            identity,
            PROVISIONED_UI_FLAGS.RELEASE_PREMIUM_UPSELL_DRAWER_UI,
            'true',
        ),
    }
}

export const PREMIUM_TRIAL_FLAGS = Object.freeze({
    PREMIUM_TRIAL_SELF_SERVE: 'PREMIUM_TRIAL_SELF_SERVE',
})

export const TRIAL_ACTIVATION_SUCCESS = 'trial_activated_successfully'
export const EMAIL_NOT_VERIFIED = 'email_not_verified'
export const USER_ADDED_TO_BUSINESS_ACCOUNT =
    'user_added_to_business_account_trial'
export const MISSING_SALESFORCE_ACCOUNT = 'salesforce_account_not_found'
export const PREMIUM_RETRIAL = 'user_requesting_retrial'
export const PENDING_BA_INVITATION = 'pending_ba_invitation'
